import * as React from 'react'

function IconHere() {
  return (
    <svg
      width={40}
      height={50}
      viewBox="0 0 40 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M20 5C11.716 5 5 11.852 5 20.303c0 8.017 6.593 17.405 11.037 22.818a5.074 5.074 0 007.892-.011C28.373 37.64 35 28.16 35 20.303 35 11.853 28.284 5 20 5z"
          fill="#E84E25"
        />
        <circle cx={20} cy={21} r={6} stroke="#fff" strokeWidth={3} />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x={0}
          y={0}
          width={40}
          height={50}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={2.5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default IconHere
